<template>
  <div :class="prefixCls">
    <z-panel
      v-if="!add"
      type="image"
      :width="width"
      :height="height"
      :animation="animation"
      :imageUrl="url"
    ></z-panel>
    <div v-if="!add" :class="prefixCls+'-dec'" :style="{'width': width+'px'}">
      <slot></slot>
    </div>
    <div v-if="add" :class="prefixCls + '-add'" @click="addProjectHandle" :style="{'width': width+'px', 'height': height + 'px', 'line-height': height + 'px'}">
      <Button type="primary" >
          <i class="iconfont icon-plus-m"></i>
      </Button>
    </div>
    <div v-if="add" :class="prefixCls+'-dec'" :style="{'width': width+'px'}">
      添加项目
    </div>
  </div>
</template>

<script>
const prefixCls = "zProject";
import ZPanel from '../panel/panel'
export default {
  name: "ZPreject",
  data() {
    return {
      prefixCls: prefixCls
    };
  },
  components: {ZPanel},
  props: {
    width: {
      type: [String, Number],
      default: 100
    },
    height: {
      type: [String, Number],
      default: 100
    },
    animation: {
      type: Boolean,
      default: true
    },
    url: {
      type: String
    },
    // 是否是添加按钮
    add: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addProjectHandle() {
      this.$emit('addProject')
    }
  }
};
</script>

